import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import Home from './pages/Home';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Security from './components/Security';

const Contact = lazy(() => import('./pages/Contact'));
const Store = lazy(() => import('./pages/Store'));
const Proxy = lazy(() => import('./pages/Proxy'));
const SMM = lazy(() => import('./pages/SMM'));
const Directory = lazy(() => import('./pages/Directory'));
const Blog = lazy(() => import('./pages/Blog'));
const FAQ = lazy(() => import('./pages/FAQ'));
const About = lazy(() => import('./pages/About'));
const Terms = lazy(() => import('./pages/Terms'));
const Privacy = lazy(() => import('./pages/Privacy'));
const Services = lazy(() => import('./pages/Services'));
const ServicesKiotSo = lazy(() => import('./pages/services/KiotSo'));
const ServicesProxy = lazy(() => import('./pages/services/Proxy'));
const ServicesSMM = lazy(() => import('./pages/services/SMM'));
const ServicesKiotTool = lazy(() => import('./pages/services/KiotTool'));

function App() {
  return (
    <Router>
      <Security />
      <div className="flex flex-col min-h-screen bg-dark text-white font-montserrat">
        <Navbar />
        <main className="flex-grow">
          <Suspense fallback={null}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/store" element={<Store />} />
              <Route path="/proxy" element={<Proxy />} />
              <Route path="/smm" element={<SMM />} />
              <Route path="/directory" element={<Directory />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/about" element={<About />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />

              <Route path="/services" element={<Services />} />
              <Route path="/services/kiotso" element={<ServicesKiotSo />} />
              <Route path="/services/proxy" element={<ServicesProxy />} />
              <Route path="/services/smm" element={<ServicesSMM />} />
              <Route path="/services/kiottool" element={<ServicesKiotTool />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App; 